<div class="c-content c-content--wrapper u-no-p" [ngStyle]="vm.loading && {'min-height': '300px'}">
	<div *ngIf="!vm.loading">
		<div class="c-content u-no-ph@md-and-up u-hidden@up-to-md">
			<div class="o-grid o-grid--center-v">
				<div class="o-grid__cell o-grid__cell--w-50 o-grid__cell--w-33@lg-and-up u-no-p o-grid__cell--left">
					<form class="c-form">
						<div class="o-grid">
							<div class="o-grid__cell o-grid__cell--slim o-grid__cell--w-fixed u-no-p">
								<a id="addTherapyFundWalletButton" class="c-button c-button--s1 c-button--fit" (click)="vm.addWallet()">{{ 'TherapyFundWallet.Add' | translate }}</a>
							</div>
						</div>
					</form>
				</div>
				<div class="o-grid__cell o-grid__cell--w-50 o-grid__cell--w-33@lg-and-up u-no-p o-grid__cell--right">
					<form class="c-form">
						<div class="o-grid">
							<div class="o-grid__cell o-grid__cell--slim">
								<div class="c-form__group c-form__group--icon u-osb-sm">
									<i class="o-icon o-icon--search c-form__icon" aria-hidden="true"></i>
									<input id="searchInput" name="searchInput" type="text" class="c-form__input c-form__input--sm" placeholder="{{ 'TherapyFundWallet.Search_Placeholder' | translate }}" spellcheck="false" [(ngModel)]="vm.term" (ngModelChange)="onSearchChange($event)">
								</div>
							</div>
							<div class="o-grid__cell o-grid__cell--slim o-grid__cell--w-fixed u-no-p">
								<a href="{{vm.csvDownloadUrl}}" target="_self" download="wallet-report.csv" class="c-button c-button--s1 c-button--fit">{{ 'Common.Download' | translate }}</a>
							</div>
						</div>
					</form>
				</div>
			</div>
		</div>
		<div class="c-content c-content--border-bottom u-no-ph@md-and-up u-hidden@up-to-md">
			<div class="o-grid o-grid--wrap">
				<div class="o-grid__cell o-grid__cell--w-15 u-no-p">
					<a href="javascript:void(0)" class="c-text c-text--gray" (click)="vm.setFilter('created')" aria-hidden="true"><span style="vertical-align:middle">{{ 'TherapyFundWallet.Created' | translate }}</span>&nbsp;<span *ngIf="vm.filter.orderBy==='created' && vm.filter.ascending">&#8595;</span><span *ngIf="vm.filter.orderBy==='created' && !vm.filter.ascending">&#8593;</span></a>
				</div>
				<div class="o-grid__cell o-grid__cell--w-25 u-no-p">
					<a href="javascript:void(0)" class="c-text c-text--gray" (click)="vm.setFilter('name')" aria-hidden="true"><span style="vertical-align:middle">{{ 'TherapyFundWallet.Name' | translate }}</span>&nbsp;<span *ngIf="vm.filter.orderBy==='name' && vm.filter.ascending">&#8595;</span><span *ngIf="vm.filter.orderBy==='name' && !vm.filter.ascending">&#8593;</span></a>
				</div>
				<div class="o-grid__cell o-grid__cell--w-10 u-no-p">
					<a href="javascript:void(0)" class="c-text c-text--gray" (click)="vm.setFilter('active')" aria-hidden="true"><span style="vertical-align:middle">{{ 'TherapyFundWallet.Active' | translate }}</span>&nbsp;<span *ngIf="vm.filter.orderBy==='active' && vm.filter.ascending">&#8595;</span><span *ngIf="vm.filter.orderBy==='active' && !vm.filter.ascending">&#8593;</span></a>
				</div>
				<div class="o-grid__cell o-grid__cell--w-10 u-no-p">
					<span class="c-text c-text--gray" style="vertical-align:middle">{{ 'TherapyFundWallet.Usage' | translate }}</span>
				</div>
				<div class="o-grid__cell o-grid__cell--w-15 u-no-p">
					<span class="c-text c-text--gray" style="vertical-align:middle">{{ 'TherapyFundWallet.ValidFrom' | translate }}</span>
				</div>
				<div class="o-grid__cell o-grid__cell--w-15 u-no-p">
					<span class="c-text c-text--gray" style="vertical-align:middle">{{ 'TherapyFundWallet.ValidTo' | translate }}</span>
				</div>
			</div>
		</div>
		<ul class="c-list">
			<li *ngFor="let wallet of vm.wallets | startFrom:vm.currentPage*vm.pageSize | arrayLimitTo:vm.pageSize ; let $index=index">
				<div class="c-content c-content--border-bottom u-no-ph@md-and-up" [hidden]="wallet.deleted">
					<div id="wallet-action-element-{{wallet.id}}" class="o-grid o-grid--wrap@up-to-md">
						<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-15@md-and-up u-no-p">
							<div class="o-grid o-grid--center-v u-hidden@md-and-up">
								<div class="o-grid__cell u-no-p">
									<p class="c-text c-text--sm c-text--gray u-hidden@md-and-up">{{ 'TherapyFundWallet.Created' | translate }}:</p>
								</div>
								<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--right u-no-p">
									<p class="c-text c-text--sm@up-to-md">
										{{ wallet.created | date:'dd.MM.yyyy' }}<span class="u-hidden@up-to-md"> {{ wallet.created | date:'HH:mm:ss' }}</span>
									</p>
								</div>
							</div>
							<p class="c-text c-text--sm@up-to-md c-text--s10 u-hidden@up-to-md">
								{{ wallet.created | date:'dd.MM.yyyy' }}<span class="u-hidden@up-to-md"> {{ wallet.created | date:'HH:mm:ss' }}</span>
							</p>
						</div>
						<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-25@md-and-up u-no-p o-grid__cell--o1@md-and-up">
							<div class="o-grid o-grid--center-v u-hidden@md-and-up">
								<div class="o-grid__cell u-no-p">
									<p class="c-text c-text--sm c-text--gray u-hidden@md-and-up">{{ 'TherapyFundWallet.Name' | translate }}:</p>
								</div>
								<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--right u-no-p">
									<p class="c-text c-text--sm@up-to-md">
										{{ wallet.user.firstname }} {{ wallet.user.lastname }} {{ wallet.user.personalCode ? '(' + wallet.user.personalCode + ')' : ''}}
									</p>
								</div>
							</div>
							<p class="c-text c-text--bold@up-to-md u-hidden@up-to-md">
								{{ wallet.user.firstname }} {{ wallet.user.lastname }} {{ wallet.user.personalCode ? '(' + wallet.user.personalCode + ')' : ''}}
							</p>
						</div>
						<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-10@md-and-up u-no-p o-grid__cell--o1@md-and-up">
							<div class="o-grid o-grid--center-v u-hidden@md-and-up">
								<div class="o-grid__cell u-no-p">
									<p class="c-text c-text--sm c-text--gray u-hidden@md-and-up">{{ 'TherapyFundWallet.Active' | translate }}:</p>
								</div>
								<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--right u-no-p">
									<p class="c-text c-text--sm@up-to-md">
										{{ ((wallet.active) ? 'Common.Yes' : 'Common.No') | translate }}
									</p>
								</div>
							</div>
							<p class="c-text u-hidden@up-to-md">{{ ((wallet.active) ? 'Common.Yes' : 'Common.No') | translate }}</p>
						</div>
						<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-10@md-and-up u-no-p o-grid__cell--o1@md-and-up">
							<div class="o-grid o-grid--center-v u-hidden@md-and-up">
								<div class="o-grid__cell u-no-p">
									<p class="c-text c-text--sm c-text--gray u-hidden@md-and-up">{{ 'TherapyFundWallet.Usage' | translate }}:</p>
								</div>
								<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--right u-no-p">
									<p class="c-text c-text--sm@up-to-md">
										{{ wallet.limit - wallet.balance }}/{{ wallet.limit}}
									</p>
								</div>
							</div>
							<p class="c-text c-text--bold@up-to-md u-hidden@up-to-md">
								{{ wallet.limit - wallet.balance }}/{{ wallet.limit}}
							</p>
						</div>
						<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-15@md-and-up u-no-p o-grid__cell--o1@md-and-up">
							<div class="o-grid o-grid--center-v u-hidden@md-and-up">
								<div class="o-grid__cell u-no-p">
									<p class="c-text c-text--sm c-text--gray u-hidden@md-and-up">{{ 'TherapyFundWallet.ValidFrom' | translate }}:</p>
								</div>
								<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--right u-no-p">
									<p class="c-text c-text--sm@up-to-md">
										{{ wallet.validFrom | date:'dd.MM.yyyy' }}
									</p>
								</div>
							</div>
							<p class="c-text c-text--sm@up-to-md c-text--s10 u-hidden@up-to-md">
								{{ wallet.validFrom | date:'dd.MM.yyyy' }}
							</p>
						</div>
						<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-15@md-and-up u-no-p o-grid__cell--o1@md-and-up">
							<div class="o-grid o-grid--center-v u-hidden@md-and-up">
								<div class="o-grid__cell u-no-p">
									<p class="c-text c-text--sm c-text--gray u-hidden@md-and-up">{{ 'TherapyFundWallet.ValidTo' | translate }}:</p>
								</div>
								<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--right u-no-p">
									<p class="c-text c-text--sm@up-to-md">
										{{ wallet.validTo | date:'dd.MM.yyyy' }}
									</p>
								</div>
							</div>
							<p class="c-text c-text--sm@up-to-md c-text--s10 u-hidden@up-to-md">
								{{ wallet.validTo | date:'dd.MM.yyyy' }}
							</p>
						</div>
						
						<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fixed@md-and-up u-no-p o-grid__cell--o3@md-and-up o-grid__cell--right u-ost-md@up-to-md">
							<p class="c-text c-text--right" *ngIf="wallet.active">
								<a href="javascript:void(0)" class="c-text c-text--uppercase c-text--bold u-osl-md" (click)="vm.deactivate(wallet)">{{ 'TherapyFundWallet.Button_Deactivate' | translate }}</a>
							</p>
						</div>
					</div>
				</div>
			</li>
		</ul>
		<item-no-content *ngIf="!vm.wallets?.length"></item-no-content>
	</div>
	<loader-overlay *ngIf="vm.loading"></loader-overlay>
</div>
